module.exports = __webpack_public_path__ + "assets/img/mtTitle-3273d336.png";